/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { shipmentControllerCreate } from '../fn/shipment/shipment-controller-create';
import { ShipmentControllerCreate$Params } from '../fn/shipment/shipment-controller-create';
import { shipmentControllerDelete } from '../fn/shipment/shipment-controller-delete';
import { ShipmentControllerDelete$Params } from '../fn/shipment/shipment-controller-delete';
import { shipmentControllerFindByPigId } from '../fn/shipment/shipment-controller-find-by-pig-id';
import { ShipmentControllerFindByPigId$Params } from '../fn/shipment/shipment-controller-find-by-pig-id';
import { shipmentControllerUpdate } from '../fn/shipment/shipment-controller-update';
import { ShipmentControllerUpdate$Params } from '../fn/shipment/shipment-controller-update';
import { ShipmentDto } from '../models/shipment-dto';

@Injectable({ providedIn: 'root' })
export class ShipmentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `shipmentControllerCreate()` */
  static readonly ShipmentControllerCreatePath = '/api/shipments';

  /**
   * 출하 정보 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shipmentControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shipmentControllerCreate$Response(params: ShipmentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipmentDto>> {
    const obs = shipmentControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 출하 정보 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shipmentControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shipmentControllerCreate(params: ShipmentControllerCreate$Params, context?: HttpContext): Observable<ShipmentDto> {
    const resp = this.shipmentControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShipmentDto>): ShipmentDto => r.body)
    );
  }

  /** Path part for operation `shipmentControllerFindByPigId()` */
  static readonly ShipmentControllerFindByPigIdPath = '/api/shipments/pig/{pigId}';

  /**
   * 돼지별 출하 정보 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shipmentControllerFindByPigId()` instead.
   *
   * This method doesn't expect any request body.
   */
  shipmentControllerFindByPigId$Response(params: ShipmentControllerFindByPigId$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipmentDto>> {
    const obs = shipmentControllerFindByPigId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 돼지별 출하 정보 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shipmentControllerFindByPigId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shipmentControllerFindByPigId(params: ShipmentControllerFindByPigId$Params, context?: HttpContext): Observable<ShipmentDto> {
    const resp = this.shipmentControllerFindByPigId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShipmentDto>): ShipmentDto => r.body)
    );
  }

  /** Path part for operation `shipmentControllerDelete()` */
  static readonly ShipmentControllerDeletePath = '/api/shipments/{id}';

  /**
   * 출하 정보 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shipmentControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  shipmentControllerDelete$Response(params: ShipmentControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipmentDto>> {
    const obs = shipmentControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 출하 정보 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shipmentControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shipmentControllerDelete(params: ShipmentControllerDelete$Params, context?: HttpContext): Observable<ShipmentDto> {
    const resp = this.shipmentControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShipmentDto>): ShipmentDto => r.body)
    );
  }

  /** Path part for operation `shipmentControllerUpdate()` */
  static readonly ShipmentControllerUpdatePath = '/api/shipments/{id}';

  /**
   * 출하 정보 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shipmentControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shipmentControllerUpdate$Response(params: ShipmentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipmentDto>> {
    const obs = shipmentControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 출하 정보 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shipmentControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shipmentControllerUpdate(params: ShipmentControllerUpdate$Params, context?: HttpContext): Observable<ShipmentDto> {
    const resp = this.shipmentControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ShipmentDto>): ShipmentDto => r.body)
    );
  }

}
